import React from 'react';

const Hero: React.FC = () => {
  return (
    <section id="home" className="relative h-screen flex items-center justify-center bg-gradient-to-b from-black to-blue-900 text-white">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-black opacity-50"></div>
      </div>
      
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight mb-4 animate-pulse">
          <span className="block text-blue-300">ShourShivKrish Band</span>
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
          Three 9-year-old musical prodigies bringing you amazing performances on piano, guitar, drums, and vocals
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a
            href="#music"
            className="px-8 py-3 text-lg font-medium rounded-full bg-blue-600 hover:bg-blue-700 transition-colors duration-300"
          >
            Listen Now
          </a>
          <a
            href="#about"
            className="px-8 py-3 text-lg font-medium rounded-full bg-transparent border-2 border-white hover:bg-white hover:text-blue-900 transition-colors duration-300"
          >
            Meet the Band
          </a>
          <a
            href="#contact"
            className="px-8 py-3 text-lg font-medium rounded-full bg-purple-600 hover:bg-purple-700 transition-colors duration-300"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
